var $3e76343654ae8c22$exports = {};
const $3e76343654ae8c22$var$Configuration = {
    apiUrl: "https://api.staging.hint.com",
    apiVersion: "20261022175034",
    emrNotesUrl: "https://api.one.staging.hint.com/notes",
    emrNotesVersion: undefined,
    emrNotesCsp: "https://api.one.staging.hint.com/notes/",
    emrCalendarsUrl: "https://api.one.staging.hint.com/calendars",
    emrCalendarsVersion: undefined,
    emrCalendarsCsp: "https://api.one.staging.hint.com/calendars/",
    emrMessagingUrl: "https://api.one.staging.hint.com/messaging",
    emrMessagingVersion: undefined,
    emrMessagingCsp: "https://api.one.staging.hint.com/messaging/",
    env: "staging",
    hintEnv: "staging",
    fullStoryOrgId: undefined,
    googleMapsKey: "AIzaSyCxmha8wa6V2LP3PRgLePsIABcYxZ_-oww",
    googleRecaptchaSiteKey: "6LfHJdgZAAAAAKvTxun6iCdua-WVH0_zLqdjRh8G",
    intercomAppId: undefined,
    newRelicAccountId: "1295351",
    newRelicLicenseKey: "f80caba954",
    newRelicApplicationId: "784038116",
    release: "e5e3f5bb3422d698c5bbf2a869c6e87eb75a3291",
    sentryOrganizationId: "o4505133335904256",
    sentryProjectId: "4505286157729792",
    sentryKey: "558356d795f64c16a85cce356d98018c",
    sentryEnvironment: "staging",
    sentryReleaseVersion: "e5e3f5bb3422d698c5bbf2a869c6e87eb75a3291",
    stripePublishableKey: "pk_test_Y7byiIyWmjqy4Xy7fjArJdPl",
    statuspageEmbedCode: undefined,
    emrChatAttachmentCsp: "https://*.s3.us-east-1.amazonaws.com",
    enableMeticulous: false
};
$3e76343654ae8c22$exports = $3e76343654ae8c22$var$Configuration;


window.CONFIGURATION = $3e76343654ae8c22$exports;


//# sourceMappingURL=member-portal-elm.472e2254.js.map
